module.exports = __webpack_public_path__ + "img/gf.e1293045.svg";